import { LegalPolicyScreen } from './legalPolicyScreen';

const props = [ 'policyType' ];

export const LegalPolicyScreenDirective = reactDirective => reactDirective(LegalPolicyScreen, props);
LegalPolicyScreenDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('legalPolicyScreen', LegalPolicyScreenDirective);